import { openDB } from 'idb';
import { STORAGE_QUEUE_DB } from '../config';

// Une seule table : les pièces mesurées en attente d'envoi. C'est la SEULE donnée qui a besoin
// de survivre hors-ligne — le référentiel (illustration, vidéos, quota) n'est que de la lecture
// et se recharge dès le retour du réseau.
const DB_VERSION = 1;
const STORE = 'pieces';

let dbPromise = null;

function getDb() {
  if (!dbPromise) {
    dbPromise = openDB(STORAGE_QUEUE_DB, DB_VERSION, {
      upgrade(db) {
        const store = db.createObjectStore(STORE, { keyPath: 'localId', autoIncrement: true });
        store.createIndex('bySession', 'sessionId');
      },
    });
  }
  return dbPromise;
}

/** `item` : { sessionId, pieceId (null si création), mode: 'create'|'update', payload, meta, erreur? } */
export async function ajouterEnFile(item) {
  const db = await getDb();
  return db.add(STORE, { ...item, creeLe: Date.now(), erreur: null });
}

export async function listerFile(sessionId) {
  const db = await getDb();
  const tous = await db.getAllFromIndex(STORE, 'bySession', sessionId);
  return tous.sort((a, b) => a.creeLe - b.creeLe);
}

export async function listerFileTotale() {
  const db = await getDb();
  return db.getAll(STORE);
}

export async function supprimerDeLaFile(localId) {
  const db = await getDb();
  return db.delete(STORE, localId);
}

export async function marquerErreur(localId, erreur) {
  const db = await getDb();
  const item = await db.get(STORE, localId);
  if (!item) return;
  await db.put(STORE, { ...item, erreur });
}
